// Do NOT add "use client"
import { IGetSearchProductsInfoResponse } from "@faire/web-api--source/indigofair/data/IGetSearchProductsInfoResponse";

export interface SearchPageData {
  productsData: SearchPageProductsData | undefined;
  loading: boolean;
  isError: boolean;
  error: unknown;
  dataUpdatedAt: number | undefined;
  rscPageLoadKey: string;
}

export interface SearchPageProductsData {
  response?: Promise<IGetSearchProductsInfoResponse | undefined>;
  productTokens?: Promise<(string | undefined)[] | undefined>;
  legacyResponse?: IGetSearchProductsInfoResponse | undefined;
  legacyProductTokens?: (string | undefined)[] | undefined;
}

export const INITIAL_SEARCH_PAGE_DATA: SearchPageData = {
  productsData: undefined,
  loading: true,
  isError: false,
  error: undefined,
  dataUpdatedAt: undefined,
  rscPageLoadKey: "",
};
